import { useTheme } from '@mui/material/styles';

import { HEADER_HEIGHT, VERTICAL_MARGIN } from '@/core/constants/layout';

type Props = {
	displayLogo?: boolean;
	displaySearchBar?: boolean;
};

export const useHeaderStyles = ({ displayLogo, displaySearchBar }: Props) => {
	const theme = useTheme();

	return {
		root: {
			backgroundColor: 'orange.main',
			height: `${HEADER_HEIGHT}px`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent:
				displayLogo || displaySearchBar ? 'space-between' : 'flex-end',
			alignItems: 'center',
			width: '100%',
			py: VERTICAL_MARGIN
		},

		headerContainer: {
			display: 'grid',
			gridTemplateColumns: '1fr minmax(50px, 663px) 1fr',
			alignItems: 'center',
			width: '100%',
			gap: 2,
			px: 2
		},

		logoContainer: {
			display: 'flex',
			flexDirection: 'row',
			gap: 2
		},

		appLogoContainer: {
			display: 'flex',
			alignItems: 'center',
			flexGrow: 0,
			cursor: 'pointer'
		},

		appLogo: {
			width: '231px',
			height: '28px',

			[theme.breakpoints.down('md')]: {
				width: '129px',
				height: '18px'
			}
		},

		appLogoMobile: {
			width: 32,
			height: 32
		}
	};
};
